import React from 'react'
import { useApiQuery } from '../../../utils/api'
import { useNavigate } from 'react-router-dom'
import { Loading, Error } from '../../Elements/Indicators'
import { PageHeader } from '../../Elements/PageHeader'
import ProjectUserSelector from '../Projects/ProjectUserSeletor'
import { Header3 } from '../../Elements/Type'
import { XProject, JiraUser } from '@jirax/common'

interface Board {
  id: string;
  name: string;
}

interface ProjectData extends XProject {
  users: JiraUser[]; // Updated to use JiraUser
  boards: Board[];
}

const Users: React.FC = () => {
  const navigate = useNavigate()
  const {
    isLoading,
    error,
    data: projects
  } = useApiQuery<ProjectData[]>(['projects'])

  if (isLoading) {
    return <Loading message={'Loading projects.'} />
  }

  if (error) {
    return <Error message={(error as Error).message} />
  }

  if (projects) {
    projects.sort((a, b) => (a.id > b.id ? -1 : 1))

    return (
      <>
        <PageHeader config={{ pageTitle: 'Users' }} key={'UsersList'} />
        <main>
          <div className='mx-auto max-w-7xl sm:px-6 lg:px-8'>
            <div className='px-4 pb-8 sm:px-0'>
              {projects.map(project => (
                <div className='pb-8' key={project.id}>
                  <Header3 title={project.name} />
                  <div className='min-h-max'>
                    <ProjectUserSelector
                      project={project}
                      /* capture project key for new route pattern */
                      onChangeUser={(userId: string) =>
                        navigate(`/users/${userId}/stats/${project.key}`)
                      }
                      user={null} // Adding null user prop to satisfy the component requirements
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </main>
      </>
    )

  } else {
    return <Error message={'No projects found.'} />
  }

}

export default Users
